module.exports = __webpack_public_path__ + "img/5_48.6fe91fff.png";